import './App.css';
import Header from './Components/Header'
import Dashboard from './Pages/Dashboard'

function App() {
  return (
    <div className="App">
      <Header />
      <Dashboard /> 
    </div>
  );
}

export default App;
